interface TableCellProps {
  value: string;
  isEditing: boolean;
  onChange: (newValue: string) => void;
  onStartEdit: () => void;
  onEndEdit: () => void;
}

export const TableCell = ({
  value,
  isEditing,
  onChange,
  onStartEdit,
  onEndEdit
}: TableCellProps) => {
  if (isEditing) {
    return (
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onEndEdit}
        autoFocus
        className="w-full p-2 border rounded min-h-[40px]"
      />
    );
  }

  return (
    <div 
      onClick={onStartEdit} 
      className="cursor-pointer p-2 min-h-[40px]"
    >
      {value}
    </div>
  );
}; 